const list = () => import('./list');
const edit = () => import('./edit');
const example = () => import('./example');
const taskVideo = () => import('./video');
const assignmentTaskList = () => import('./assignmentTaskList');

const taskRouter = [
  {
    path: '/task/list/:country', name: 'tasklist', component: list, meta: { c: 'task', a: 'list' }
  },
  {
    path: '/task/edit/:country/:taskId', name: 'taskEdit', component: edit, meta: { c: 'task', a: 'edit' }
  },
  {
    path: '/task/example/:country/:taskId', name: 'taskExample', component: example, meta: { c: 'task', a: 'example' }
  },
  {
    path: '/task/video/:country/:taskId', name: 'taskVideo', component: taskVideo, meta: { c: 'task', a: 'video' }
  },
  {
    path: '/task/assignmentTaskList/:country', name: 'assignmentTaskList', component: assignmentTaskList, meta: { c: 'task', a: 'assignmentTaskList' }
  },
];

export default taskRouter;

